/*
This is a facade of the jQueryUI slider plugin.  It's goals are:
 1. Encapsulate all rtl rendering logic.
 2. Consistently return Min and Max values, rather than sometimes returning a values array or sometimes single value.
 3. Validate Min and Max values.
*/

(function () {
    const rtl = (values: number[]) => TRPCONFIG.Rtl ? _.chain(values).reverse().map(x => -x).value() : values;
    const withMinMax = func => ['Min', 'Max'].forEach(func);

    jQuery.fn.rtlSlider = function(setup) {
        const $elem = $(this);
        const oldSlide = setup.slide;
        withMinMax(prop => setup[prop] = setup[prop.toLowerCase()]);
        setup.slide = function(event, ui) {
            ui.model = toModel(setup.dual ? ui.values : ui.value);
            oldSlide.apply(setup, arguments);
        };
        // range can be either true/min/max.
        setup.range = setup.range === undefined ? setup.dual : setup.range;
        if (TRPCONFIG.Rtl) {
            setup.range = { min: 'max', max: 'min' }[setup.range] || setup.range;
        }
        $elem.slider(setup);
        setSliderPosition();
        return setSliderPosition;

        function validateModel(model) {
            model = angular.copy(model || {});
            withMinMax(prop => {
                let value = model[prop];
                let isValid = angular.isNumber(value) && value >= setup.min && value <= setup.max;
                model[prop] = isValid ? value : setup[prop];
            });
            return model;
        }
        function toModel(values) {
            if (!angular.isArray(values)) {
                values = [values, values];
            }
            values = rtl(values);
            let model = { Min: values[0], Max: values[1] };
            model = validateModel(model);
            withMinMax(prop => {
                let edgesBecomeNull = setup.edgesBecomeNull[prop];
                if (edgesBecomeNull && model[prop] === setup[prop]) {
                    model[prop] = null;
                }
            });
            return model.Min === null && model.Max === null ? null : model;
        }
        function fromModel(model) {
            model = validateModel(model);
            let values = [model.Min, model.Max];
            values = rtl(values);
            return setup.dual ? values : values[0];
        }
        function setSliderPosition(model?) {
            let values = fromModel(model);
            let type = setup.dual ? 'values' : 'value';
            $elem.slider(type, values);
        }
    };
})();
